const reportingFilterFrequencyConst =
{
  Monthly: '1',
  Daily: '2',
};

module.exports = {
  reportingFilterFrequencyConst
}
